//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {

	props: {
		src: {
			type: String,
			//required: true
		},
		vip: {
			type: Number
		},        
		isOffical: {
			type: Number
		}
	},

}
